// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'

import VCharts from 'v-charts'
import ElementUI from 'element-ui';
import VueLazyload from 'vue-lazyload'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VerifyCode from '@/components/verify-code'
// import SlideVerify from '@/components/slide-verify'
import md5 from 'js-md5';
import './axios_config'
import routesMap from "@/router/routesMap";

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import '@/assets/css/reset-element.css'

Vue.prototype.$md5 = md5
Vue.use(VerifyCode)
// Vue.use(SlideVerify)
Vue.use(VCharts)
Vue.use(ElementUI);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://packer-model-files.oss-cn-shenzhen.aliyuncs.com/ed57283054794d94c9406e6bac9482a3.png',
  loading: 'https://packer-model-files.oss-cn-shenzhen.aliyuncs.com/9733b3b738499c4f1adb56ad0132546c.gif',
  attempt: 1
})
Vue.component(VueQrcode.name, VueQrcode);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let accountInfo = JSON.parse(sessionStorage.getItem("accountInfo"));
  if (accountInfo) {
    let indexPath = ""
    if (accountInfo.account_type == 3) {
      indexPath = "/super/index"
    } else if (accountInfo.account_type == 2) {
      indexPath = "/merchant/company_index"
    } else if (accountInfo.account_type == 1) {
      indexPath = "/shop/index"
    }
    if (to.path != "/" && to.path != "/h5_face_collection" && to.path != "/login" && to.path != "/super/index" && to.path != "/merchant/company_index" && to.path != "/merchant/shop_index" && to.path != "/shop/index" && to.path != "/excel") {
      // 为了保证当前路由地址在所选的角色权限路由地址中，否则回到主页
      let routes = []
      let otherRoutes = []
      let routeIdList = eval("(" + accountInfo.role_permission + ")")
      let routePath = ""
      let routeId = ""
      if (accountInfo.account_type == 3) {
        routes = routesMap.superRoutes
        otherRoutes = routesMap.superOtherRoutes
      } else if (accountInfo.account_type == 2) {
        routes = routesMap.merchantRoutes
        otherRoutes = routesMap.merchantOtherRoutes
      } else if (accountInfo.account_type == 1) {
        routes = routesMap.shopRoutes
        otherRoutes = routesMap.shopOtherRoutes
      }
      otherRoutes.map(v => {
        v.children.map(c => {
          c.meta.map((m, index) => {
            if (m.path == to.path) {
              routePath = c.meta[0].path
            }
          })
        })
      })
      if (routePath) {
        routes.map(v => {
          v.children.map(c => {
            if (c.path == routePath) {
              routeId = c.id
            }
          })
        })
      } else {
        routes.map(v => {
          v.children.map(c => {
            if (c.path == to.path) {
              routeId = c.id
            }
          })
        })
      }
      if (routeIdList.indexOf(routeId) == -1) {
        next(indexPath)
      } else {
        next()
      }
    } else {
      if (to.path == "/") {
        next(indexPath)
      }
      if (to.path == '/super/index' && accountInfo.account_type != 3) {
        next("/not_found_page")
      }
      if ((to.path == '/merchant/company_index' || to.path == '/merchant/shop_index') && accountInfo.account_type != 2) {
        next("/not_found_page")
      }
      if (to.path == '/shop/index' && accountInfo.account_type != 1) {
        next("/not_found_page")
      }
      next()
    }
  } else {
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  data: {
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js